import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import useAxiosProtect from '../../../hooks/useAxiosProtect';
import useAuth from '../../../hooks/useAuth';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';

const EditTaskModal = props => {
    const [editType, setEditType] = useState('instance');
    const [taskStatus, setTaskStatus] = useState('');                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
    const [eventDate, setEventDate] = useState(dayjs(new Date().toLocaleString('sv-SE', { timeZoneName: 'short' }).slice(0, 16).replace(' ', 'T')));
    const [dateErr, setDateErr] = useState('');
    const [title, setTitle] = useState('');
    const [titleErr, setTitleErr] = useState('');
    const [category, setCategory] = useState('task');
    const [customCategory, setCustomCategory] = useState('');
    const [customCategoryErr, setCustomCategoryErr] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('');
    const maxDescLength = 128;
    const maxTitleLength = 64;
    const maxCategoryLength = 64;
    const {auth, persist} = useAuth();
    const axiosProtect = useAxiosProtect();

    const [opps, setOpps] = useState([]);
    const [selectedOpp, setSelectedOpp] = useState(null);
    const [isOpp, setIsOpp] = useState(false);
    const [oppErr, setOppErr] = useState('');

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] =  useState(null);

    const [originallyOpp, setOriginallyOpp] = useState(false);

    var init = useRef(true);

    useEffect(() => {
        if(props.taskToEdit == null) return;

        setTaskStatus(props.taskToEdit.status);
        setTitle(props.taskToEdit.title);
        setCategory(props.taskToEdit.category);
        setDescription(props.taskToEdit.description);
        setEventDate(dayjs(new Date(props.taskToEdit.deadline)));
        setPriority(props.taskToEdit.priority == null ? '' : props.taskToEdit.priority.substring(0,1).toUpperCase() + props.taskToEdit.priority.substring(1, props.taskToEdit.priority.length));
        setIsOpp(props.taskToEdit.opportunity_id);
        setOriginallyOpp(props.taskToEdit.opportunity_id);

        if(!init.current) return;
        init.current = false;

        let queryID = window.location.href.split('/').slice(-1)[0];

        let userQueryString = `?role=${auth.role}&org_id=${auth.org_id}&${props.oppView ? 'opp_id' : 'site_id'}=${queryID}`;
        axiosProtect.get(`/auth/query/get-users-for-task-assignment${userQueryString}`).then(response => {
            setUsers(response.data.users);

            for(let i = 0;i<response.data.users.length;++i){
                if(response.data.users[i]._id === props.taskToEdit.manager_uid){
                    setSelectedUser(response.data.users[i]);
                    break;
                }
            }
        }).catch(err => {
            console.log(err)
        });

        if(!props.oppView){
            axiosProtect.get(`/opp/opportunities/site-opps?siteID=${queryID}`).then(response => {
                setOpps(response.data.opps);

                for(let i = 0;i<response.data.opps.length;++i){
                    if(response.data.opps[i].id == props.taskToEdit.opportunity_id){
                        setSelectedOpp(response.data.opps[i]);
                        return;
                    } 
                }
            }).catch(err => {});
        }
    }, [props.taskToEdit]);

    const formatDate = timeString => {
        const date = new Date(timeString);

        const options = {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        };
      
        return date.toLocaleString('en-US', options);
    }

    const formatTimestamp = date => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}000`;
    }

    const validateForm = () => {
        let isValid = true;
        let now = new Date();
        let evDate = new Date(formatTimestamp(new Date(eventDate)) + ' UTC');

        if(title.trim() === ''){
            setTitleErr('Required');
            isValid = false;
        }else setTitleErr('');

        if(category === 'custom' && customCategory === ''){
            setCustomCategoryErr('Required');
            isValid = false;
        }else setCustomCategoryErr('');

        if((now.getTime() + 60 * 1000) >= evDate.getTime()){
            setDateErr('Deadline must be in the future');
            isValid = false;
        }else setDateErr('');

        if(isOpp && selectedOpp == null && !originallyOpp){
            setOppErr('Required');
            isValid = false;
        }else setOppErr('');

        return isValid;
    }

    const submitEditRequest = () => {
        if(!validateForm()) return;
        let payload = {
            taskID: props.taskToEdit.id,
            isRecurring: props.taskToEdit.is_recurring,
            deadline: formatTimestamp(eventDate['$d']),
            title: title.trim(),
            category,
            customCategory,
            description: description.trim(),
            priority: priority === '' ? null : priority.toLowerCase(),
            manager_uid: selectedUser._id,
            manager_name: `${selectedUser.first_name} ${selectedUser.last_name}`,
            manager_email: selectedUser.email,
            oppID: props.taskToEdit.is_recurring ? null : isOpp ? selectedOpp.id : null
        };

        props.editTask(payload);
    }

    return(
        <Modal
            show={props.editModalOpen}
            onHide={() => props.setEditModalOpen(false)}
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                Edit Task
            </Modal.Header>

            <Modal.Body style={{overflow:'hidden', textAlign: props.editMode === 'status' ? 'center' : 'left'}}>
                {
                    props.editMode === 'status' ?
                    <>
                        <p style={{margin:'0', textAlign:'center'}}>{props.taskToEdit.title}</p>
                        <p style={{textAlign:'center', color:'grey', fontSize:'0.9rem'}}>{formatDate(props.taskToEdit.deadline)}</p>

                        {/* {
                            props.taskToEdit?.is_recurring && 
                            <>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label">Applies to</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={editType}
                                    onChange={e => {
                                        setEditType(e.target.value);
                                    }}
                                >
                                    <FormControlLabel value="instance" control={<Radio />} label="This instance" />
                                    <FormControlLabel value="all" control={<Radio />} label="Entire series" />
                                </RadioGroup>
                            </FormControl>
                            <br/>
                            <small>Note: changing the status of entire series will apply changes to all instances from current time onward. Historical instances that overdue will retain their status unless manually overridden or deleted.</small>

                            <br/>
                            <br/>
                            </>
                        } */}

                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Change status to</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={taskStatus}
                                onChange={e => {
                                    setTaskStatus(e.target.value);
                                }}
                            >
                                <FormControlLabel value="in progress" control={<Radio />} label="In progress" />
                                <FormControlLabel value="complete" control={<Radio />} label="Complete" />
                                <FormControlLabel value="on hold" control={<Radio />} label="On hold" />
                            </RadioGroup>
                        </FormControl>
                        <br/>
                        <small>Note: status changes only apply to this instance</small>
                    </>
                    :
                    <>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                            <DateTimePicker
                                label="Task due"
                                value={eventDate}
                                onChange={newDate => setEventDate(newDate)}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {dateErr !== '' && <><small className="text-error">{dateErr}</small><br/></>}

                    <br/>

                    <TextField fullWidth label='Title' value={title} onChange={e => {if(e.target.value.length <= maxTitleLength) setTitle(e.target.value)}} error={titleErr !== ''} 
                    helperText={titleErr === '' ? `${maxTitleLength - title.length} character${maxTitleLength - title.length === 1 ? '' : 's'} left` : titleErr}/>

                    <br/>
                    <br/>

                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={category}
                            label="Category"
                            onChange={e => {
                                if(e.target.value !== category){
                                    setCustomCategory('');
                                    setCustomCategoryErr('');
                                }
                                setCategory(e.target.value);
                            }}
                            MenuProps={{ disablePortal: true }}
                        >
                            <MenuItem value='task'>Maintenance task</MenuItem>
                            <MenuItem value='deadline'>Production deadline</MenuItem>
                            <MenuItem value='custom'>Custom</MenuItem>
                        </Select>
                    </FormControl>
                    
                    {
                        category === 'custom' &&
                        <>
                        <br/>
                        <br/>
                        <TextField fullWidth label='Custom task' value={customCategory} onChange={e => {if(e.target.value.length <= maxCategoryLength) setCustomCategory(e.target.value)}} error={customCategoryErr !== ''} 
                        helperText={customCategoryErr === '' ? `${maxCategoryLength - customCategory.length} character${maxCategoryLength - customCategory.length === 1 ? '' : 's'} left` : customCategoryErr}/>
                        </>
                    }

                    <br/>
                    <br/>

                    {/* <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={status}
                            label="Status"
                            onChange={e => setStatus(e.target.value)}
                            MenuProps={{ disablePortal: true }}
                        >
                            <MenuItem value='in progress'>In progress</MenuItem>
                            <MenuItem value='complete'>Complete</MenuItem>
                            <MenuItem value='overdue'>Overdue</MenuItem>
                            <MenuItem value='on hold'>On hold</MenuItem>
                        </Select>
                    </FormControl>

                    <br/>
                    <br/> */}

                    <TextField 
                        fullWidth placeholder='Description (optional)' value={description} onChange={e => {if(e.target.value.length <=  maxDescLength) setDescription(e.target.value)}} 
                        multiline rows={2} helperText={`${maxDescLength - description.length} character${maxDescLength - description.length === 1 ? '' : 's'} left`}
                    />

                    <br/>
                    <br/>

                    <Autocomplete
                        disablePortal
                        id="tk-user-autocomplete"
                        fullWidth
                        options={users}
                        autoHighlight
                        value={selectedUser}
                        onChange={(_, option) => setSelectedUser(option)}
                        getOptionLabel={(option) => option._id === auth.id ? 'You' : `${option.first_name} ${option.last_name} (${option.email})`}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                            <Box
                                key={key}
                                component="li"
                                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                {...optionProps}
                            >
                                {option._id === auth.id ? 'You' : `${option.first_name} ${option.last_name} (${option.email})`}
                            </Box>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Member assigned to task"
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                }}
                            />
                        )}
                    />

                    <br/>

                    {
                        (!props.oppView && !props.taskToEdit.is_recurring) &&
                        <>
                        <FormControlLabel control={<Checkbox checked={isOpp} onClick={() => {
                            let isOppCopy = !isOpp;
                            if(isOppCopy) setSelectedOpp(null);
                            setIsOpp(isOppCopy);
                        }}/>} label="This task is part of a conservation opportunity" />

                        {isOpp && 
                            <>
                            <br/>
                            <br/>
                            <Autocomplete
                                disablePortal
                                id="opp-autocomplete"
                                fullWidth
                                options={opps}
                                autoHighlight
                                value={selectedOpp}
                                onChange={(_, option) => setSelectedOpp(option)}
                                getOptionLabel={(option) => option.title}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                    <Box
                                        key={key}
                                        component="li"
                                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                        {...optionProps}
                                    >
                                        {option.title}
                                    </Box>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select opportunity"
                                        inputProps={{
                                            ...params.inputProps,
                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                        }}
                                    />
                                )}
                            />
                            {oppErr !== '' && <small className="text-error">{oppErr}</small>}
                            </>
                        }
                        </>
                    }
                    </>
                }
            </Modal.Body>

            <Modal.Footer>
                <div style={{display:'flex', width:'100%'}}>
                    <div style={{flex:'5', textAlign:'left', display:'flex', alignItems:'center', flexWrap:'wrap'}}>
                        <IconButton onClick={() => {
                            setPriority(priority === 'High' ? '' : 'High');
                        }}>
                            <PriorityHighIcon style={{color: priority === 'High' ? 'rgb(213,43,0)' : 'inherit'}}/>
                        </IconButton>
                        <IconButton onClick={() => {
                            setPriority(priority === 'Low' ? '' : 'Low');
                        }}>
                            <LowPriorityIcon style={{color: priority === 'Low' ? 'rgb(8,114,182)' : 'inherit'}}/>
                        </IconButton>
                        <div style={{width:'2%'}}></div>
                        <Typography variant='subtitle1'>{priority === '' ? 'Standard' : priority} priority</Typography>
                    </div>

                    <div style={{flex:'4'}}></div>

                    <Button className="btn-brand-bg" style={{flex:'1', border:'none'}} onClick={() => {
                        if(props.editMode === 'status'){
                            props.updateTaskStatus(props.taskToEdit.id, editType, taskStatus, props.taskToEdit.is_recurring);
                        }else{
                            submitEditRequest();
                        }
                    }} disabled={props.modalLoading}>
                        Update
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default EditTaskModal;